import type { AlbumDetails } from './types'
const detailCache = new Map<string, AlbumDetails>()
export async function fetchAlbumDetails(
  id: string,
): Promise<{ details: AlbumDetails | null; error: string | null }> {
  const cached = detailCache.get(id)
  if (cached) return { details: cached, error: null }
  try {
    const response = await fetch(`/api/rotation/albums/${id}`, {
      signal: AbortSignal.timeout(15000),
    })
    if (!response.ok) throw new Error('Track list unavailable')
    const details: AlbumDetails = await response.json()
    detailCache.set(id, details)
    return { details, error: null }
  } catch {
    return { details: null, error: 'The track list could not load.' }
  }
}
